import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useBigoBusinessManagerStore = defineStore({
  id: 'bigoBusinessManagerStore',
  state: () => ({
    bigoBusinessManagers: [],
    bigoBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getBigoBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.bigoBusinessManagersLoading = true

      try {
        const {data} = await axios.get('bigo/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.bigoBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.bigoBusinessManagersLoading = false
      }
    },
  },
})
